import PrintShell, { PrintField, PrintRow, PrintSectionHeader } from '../../../components/print/PrintShell';

export default function UserPrintTemplate({ user: u }) {
  if (!u) return null;
  return (
    <PrintShell printClass="user-print-only" formTitle="USER RECORD">
      <PrintSectionHeader title="User Information" />
      <PrintField label="Name" value={u.name} />
      <PrintRow fields={[
        { label: 'Email', value: u.email },
        { label: 'Role', value: u.role, flex: 0.6 },
      ]} />
    </PrintShell>
  );
}
